<template>
    <div>
        <div class="ui container">
            <vuetable ref="vuetable"
                :http-fetch="fetchData"
                :api-mode="true"
                :api-url="$store.getters.apiBase + resources.accounts"
                :fields="listFields"
                pagination-path="pagination"
                data-path=""
                :http-options="httpOptions()"
                @vuetable:pagination-data="onPaginationData">
                <template slot="idslot" scope="props">
                    <div class="table-button-container">
                        <router-link :to="{name: 'accountDetails', params: {account_id: props.rowData.id}}">{{props.rowData.id}}</router-link>
                    </div>
                </template>
            </vuetable>
            <vuetable-pagination
                ref="pagination" @vuetable-pagination:change-page="onChangePage">
            </vuetable-pagination>
        </div>
    </div>
</template>

<style>
.pagination a.item {
    padding: 10px;
}

.pagination a.item.large {
    font-weight: bolder
}
</style>

<script>
// import Vue from "vue";
import {Vuetable, VuetablePagination} from "vuetable-2";
import axios from "axios";

const RANGE_RGX = /^(?:items\s)?(\d+)-(\d+)\/(\d+)$/;

export default {
    name: "accountsList",
    components: {
        Vuetable,
        VuetablePagination
    },
    data: () => {
        return {
            fields: [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "center aligned",
                    dataClass: "right aligned"
                },
                {
                    name: "__slot:idslot",
                    title: "id"
                },
                {
                    name: "company_name",
                    title: "Company name"
                },
                {
                    name: "email",
                    title: "email"
                }
            ],
            resources: {
                accounts: "/accounts"
            },
            page: 1,
            perPage: 10,
        };
    },
    computed: {
        listFields() {
            return this.$data.fields;
        }
    },
    methods: {
        account(accountId) {
            this.$router.push({name: "accountDetails", params: {account_id: accountId}});
        },
        fetchData(resource, options) {
            if (options && options.hasOwnProperty("params")) {
                options.headers["Range"] = "items=" + (options.params.page - 1) * options.params.per_page + "-";
                options.headers["Range"] += (options.params.page - 1) * options.params.per_page + options.params.per_page - 1;
            }

            let currentPage = options.params.page;
            let perPage = options.params.per_page;

            delete options.params.page;
            delete options.params.per_page;

            if (!options.params.sort) {
                delete options.params.sort;
            }

            return axios
                .get(resource, options)
                .then(response => {
                    let m = RANGE_RGX[Symbol.match](
                        response.headers["content-range"]
                    );

                    const from = parseInt(m[1]);
                    const to = parseInt(m[2]);
                    const total = parseInt(m[3]);

					if (!response.data) {
                    	response.data = {};
                    }
                    response.data.pagination = {
                        total: total,
                        per_page: perPage,
                        current_page: currentPage,
                        last_page: Math.ceil(total / perPage),
                        from: from,
                        to: to
                    };

                    return response;
                })
                .catch(response => {
                    console.log(response);
                });
        },

        httpOptions() {
            const _headers = {
                "Content-Type": "application/json",
                Authorization: this.$store.getters.accessToken
            };

            return {headers: _headers};
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        }
    },
    watch: {
    	"$route": "fetchData"
    },
    created() {
    	
    }
};
</script>